export const isAvailableToBuy = variant => {
    if (!variant) return;
    return variant?.inventory_quantity > 0 || variant?.allow_backorder === true;
}